<template>
  <!-- <div>
    Data management Detail
  </div> -->
  <b-row>
    <b-col cols="12" md="6">
      <profile-card
        :queryDataId="queryConfig.queryDataId"
        :queryDataKey="queryConfig.queryDataKey"
      />
    </b-col>
    <b-col cols="12" md="6">
      <overall-privilege />
    </b-col>
    <b-col cols="12">
      <privilege-table />
    </b-col>
  </b-row>
</template>

<script>
  import { BCol, BRow } from 'bootstrap-vue';
  import ProfileCard from './components/ProfileCard.vue';
  import OverallPrivilege from './components/OverallPrivilege.vue';
  import PrivilegeTable from './components/PrivilegeTable.vue';

  import useDataManagementDetail from './hooks/useDataManagementDetail';

  export default {
    components: { BCol, BRow, ProfileCard, OverallPrivilege, PrivilegeTable },

    setup() {
      const { queryConfig } = useDataManagementDetail();

      return { queryConfig };
    },
  };
</script>

<style></style>
